const textCon = {
    // menu
    home: {
        zh: '主页',
        en: 'home',
        tzh: '主頁',
    },
    about: {
        zh: '关于我们',
        en: 'about',
        tzh: '關於我們',
    },
    contact: {
        zh: '联系我们',
        en: 'contact',
        tzh: '聯繫我們',
    },
    
    jakcmall: {
        zh: 'JAKC 商场',
        en: 'JAKC mall',
        tzh: 'JAKC 商場',
    },
    office: {
        zh: '办公',
        en: 'office',
        tzh: '辦公',
    },
    residence: {
        zh: '公寓',
        en: 'residence',
        tzh: '公寓',
    },
    hotel: {
        zh: '酒店',
        en: 'hotel',
        tzh: '酒店',
    },
    address: {
        zh: '位置',
        en: 'location',
        tzh: '位置',
    },


    // footer
    footerAdd: {
        zh: '© 2024 静安嘉里中心',
        en: '© 2024 Jing An Kerry Centre',
        tzh: '© 2024 靜安嘉里中心',
    },
    footerPri: {
        zh: '隐私政策',
        en: 'Privacy Policy',
        tzh: '隱私政策',
    },
    footerR1: {
        zh: '沪ICP备 19003416号-3',
        en: '沪ICP备 19003416号-3',
        tzh: '沪ICP备 19003416号-3',
    },
    footerR2: {
        zh: '沪公网安备 31010602006468号',
        en: '沪公网安备 31010602006468号',
        tzh: '沪公网安备 31010602006468号',
    },
    
    // cookie
    cookieTitle: {
        zh: 'Cookies 使用提示',
        en: 'Cookies',
        tzh: 'Cookies 使用提示',
    },
    cookieLine1: {
        zh: '为提升您的浏览体验，本网站可能通过Cookie收集设备信息',
        en: 'To enhance your browsing experience, this website may collect device',
        tzh: '為提升您的瀏覽體驗，本網站可能透過Cookie收集裝置資訊',
    },
    cookieLine2: {
        zh: '（如浏览器类型）和您的IP地址信息等。所有数据均匿名处理，',
        en: 'information (such as browser type) and your IP address through',
        tzh: '（如瀏覽器類型）及您的IP位址等資料。所有數據均以匿名方式處理，',
    },
    cookieLine3: {
        zh: '不会关联个人身份。如不同意，请“关闭”。',
        en: 'cookies. All data is processed anonymously and is not linked to',
        tzh: '不會關聯個人身分。如不同意，請點選「關閉」。',
    },
    cookieLine4: {
        zh: '',
        en: 'personal identity. If you do not agree, please select “Close.”',
        tzh: '',
    },
    cookieAgree: {
        zh: '同意',
        en: 'agree',
        tzh: '同意',
    },
    cookieClose: {
        zh: '关闭',
        en: 'close',
        tzh: '關閉',
    }
};

export default textCon;